/**
 * PlaybookDetailForm Component
 *
 * Presentational component for editing playbook description and philosophy.
 * Stateless - receives all data and callbacks via props.
 * Reusable across desktop and mobile layouts.
 */

import React from 'react';

import { TextArea } from '@enfomentis/ui';

export interface PlaybookDetailFormProps {
  description: string;
  philosophy: string;
  onDescriptionChange: (value: string) => void;
  onPhilosophyChange: (value: string) => void;
}

export const PlaybookDetailForm: React.FC<PlaybookDetailFormProps> = ({
  description,
  philosophy,
  onDescriptionChange,
  onPhilosophyChange,
}) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-text-secondary mb-1">
          Description
        </label>
        <TextArea
          placeholder="Brief description of this playbook..."
          value={description}
          onValueChange={onDescriptionChange}
          minRows={2}
          maxRows={4}
          className="[&_textarea]:text-base"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-text-secondary mb-1">
          Philosophy
        </label>
        <TextArea
          placeholder="Describe the trading philosophy for this playbook..."
          value={philosophy}
          onValueChange={onPhilosophyChange}
          minRows={3}
          maxRows={6}
          className="[&_textarea]:text-base"
        />
      </div>
    </div>
  );
};
